// extracted by mini-css-extract-plugin
module.exports = {"propertyCell":"_1vAMRIbE","propertyLabel":"_3zWEZmrU","propertyValue":"_5SLiNKs"};